import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import JoinGroupSearch from "./JoinGroupSearch";
import { DialogActions } from "@mui/material";
import { useTranslation } from "react-i18next";

function JoinGroupDialog({ open, setOpen, handleSubmit }) {
  const { t } = useTranslation();
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>{t("library.joinDialog.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t("library.joinDialog.text")}:</DialogContentText>
        <JoinGroupSearch handleClose={handleClose} />
      </DialogContent>
      <DialogActions />
    </Dialog>
  );
}

export default JoinGroupDialog;
